/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

var DTYPES = [
	'int8',
	'int16',
	'int32',
	'int64',

	'uint8',
	'uint16',
	'uint32',
	'uint64',

	// 'float16', // TODO: uncomment once supported

	'float32',
	'float64',

	// 'complex32', // TODO: uncomment once supported

	'complex64',
	'complex128',

	'bool'
];


// EXPORTS //

export default DTYPES;
